/**
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { StyledEngineProvider } from "@mui/material/styles";
import App from "App";
import ReactDOM from "react-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import store from "redux/store";
import "rsuite/dist/rsuite.min.css";
import "suneditor/dist/css/suneditor.min.css"; // Import Sun Editor"s CSS File
import "./theme/theme-custom.css";

ReactDOM.render(
  <BrowserRouter>
    <StyledEngineProvider injectFirst>
      <Provider store={store}>
        <GoogleReCaptchaProvider
          reCaptchaKey={process.env.REACT_APP_SITE_KEY}
          scriptProps={{
            async: false,
            defer: false,
            appendTo: "head",
            nonce: undefined,
          }}
        >
          <App />
        </GoogleReCaptchaProvider>
      </Provider>
    </StyledEngineProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
